import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";

import Header from "./header/header";
import Sidebar from "./sidebar/sidebar";
import AccountPage from "./contentBody/accountPage";

import FloatingVideoChatWindow from "./videochat/FloatingVideoChatWindow";
import useAgora from "./videochat/hooks/useVideoChat";

const MainPage = () => {
  const history = useHistory();
  const [channel, setChannel] = useState(null);
  const {
    client,
    localAudioTrack,
    localVideoTrack,
    remoteUsers,
    joinState,
    isMinimized,
    setIsMinimized,
    leave,
    screenshare,
    error,
    callAgoraCred,
  } = useAgora(channel);

  useEffect(() => {
    setChannel(JSON.parse(localStorage.getItem("channel_id")));
  }, []);

  console.log("channel", channel);

  useEffect(() => {
    if (window.location.pathname !== `/patient/${channel}/videocall`) {
      setIsMinimized(true);
      if (channel) {
        callAgoraCred();
      }
    } else {
      setIsMinimized(false);
    }
  }, [channel]);

  const handleLeaveCall = () => {
    window.location.href = `/patient/${channel}/videocall`;
    setIsMinimized(false);
  };

  return (
    <>
      <div id="wrapper">
        <Sidebar />
        {isMinimized && localVideoTrack ? (
          <FloatingVideoChatWindow
            localTrack={localVideoTrack}
            remoteUsers={remoteUsers}
            onMaximize={handleLeaveCall}
            onClose={() => {
              setIsMinimized(false);
              leave();
            }}
          />
        ) : null}
        <div className="contentBody">
          <Header />
          <AccountPage />
        </div>
      </div>
    </>
  );
};
export default MainPage;
